export default __webpack_public_path__ + "media/images/features/ambassador/profiles/taichi_cohnosu_san-99c684384663c5c3173909b0d242de09.jpg";